import UserPage from 'src/pages/User';
import DashboardAppPage from 'src/pages/Dashboard';
import { Navigate, Route, Routes } from 'react-router-dom';
import DashboardLayout from 'src/layouts/dashboard/DashboardLayout';
import CustomerPage from 'src/pages/Customer';
import ResetPassword from 'src/pages/ResetPassword';
import OrderPage from 'src/pages/Order';
import OrderDetails from 'src/pages/OrderDetails';
import InventoryPage from 'src/pages/Inventory';
import DownloadPDF from 'src/pages/DownloadPDF';
import { useSelector } from 'react-redux';
import Profile from 'src/pages/Profile';
import DownloadReport from 'src/pages/DownloadReport';
import Settings from 'src/pages/Settings';
import SubOrderPage from 'src/pages/SubOrderPage';
import RevenuePage from 'src/pages/RevenuePage';
import Banks from 'src/pages/Banks';

export default function HomeRouter() {
  const { user } = useSelector((state) => state.auth);
  const notAuthRoles = user.role === 'OPERATOR' || user.role === 'CUSTOMER';
  return (
    <Routes>
      <Route path="*" element={<Navigate to={`/`} replace />} />
      <Route path="/user/reset-password" element={<ResetPassword />} />
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<DashboardAppPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/sub-order" element={<SubOrderPage />} />
        <Route path="/revenue" element={<RevenuePage />} />
        {!notAuthRoles && (
          <>
            <Route path="/administrator" element={<UserPage />} />
            <Route path="/admininstrator" element={<Navigate to="/administrator" replace />} />
            <Route path="/customer" element={<CustomerPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/banks" element={<Banks />} />
            <Route path="/settings" element={<Settings />} />
          </>
        )}
        <Route path="/order" element={<OrderPage />} />
        <Route path="/order-details" element={<OrderDetails />} />
      </Route>
      <Route path="/pdf" element={<DownloadPDF />} />
      <Route path="/order-report" element={<DownloadReport />} />
    </Routes>
  );
}
